import {Component} from 'react'
import {connect} from 'react-redux'

import AdminProfile from './Components/Profil/Admin/AdminProfile.jsx'
import LoadingProfile from './Components/Profil/Loading/LoadingProfile.jsx'
import StrategyFreelanceContainer from './StrategyFreelanceContainer.jsx'
import UserProfile from './Components/Profil/User/UserProfile.jsx'
import Loader from '../../../shared/components/Loader/Loader.jsx'

import api from '../../../api.js'
import {cancelLoader} from '../../components/CurrentUserLoader/actions.js'
import {loadUniverse} from '../../components/UniverseLoader/actions.js'
import {isAdmin} from '../../../shared/services/userService.js'

class ProfileFreelanceContainer extends Component {
  constructor(props) {
    super(props)
    props.cancelCurrentUserLoader()
    this.state = {
      view: LoadingProfile,
      profile: props.profile,
      loading: !props.profile,
    }
  }

  shouldComponentUpdate(nextProps, nextState, nextContext) {
    const profileUniverseId = nextState?.profile?.user?.mainUniverse ?? null

    return (
      (nextProps.endLoadingCurrentUser && !nextState.loading) ||
      nextProps.isAdmin !== this.props.isAdmin ||
      (profileUniverseId && profileUniverseId !== nextProps.currentUniverseId)
    )
  }

  componentDidMount() {
    if ((!this.props.profile || !this.props.profile?.user) && this.props.match.params.slug) {
      this.loadProfile()
    }
  }

  componentDidUpdate(prevProps, prevState, prevContext) {
    if ((this.props.location.pathname !== prevProps.location.pathname) || (this.props.location.search !== prevProps.location.search)) {
      this.setState({ loading: true }, () => {
        this.loadProfile()
      })
    }

    if (this.props.isAdmin !== prevProps.isAdmin || this.state.loading !== prevState.loading) {
      this.setState({
        view: this.props.isAdmin ? AdminProfile : UserProfile
      })
    }

    const profileUniverseId = this.state?.profile?.user?.mainUniverse ?? null
    if (profileUniverseId && profileUniverseId !== this.props.currentUniverseId) {
      this.props.loadUniverse(this.getUniverseById(profileUniverseId))
    }
  }

  getUniverseById = (id) => {
    return this.props.universes.filter((universe) => {
      return universe.id === id
    })[0]
  }

  loadProfile = async () => {
    try {
      const [freelanceResponse, HumanSkillsResponse] = await Promise.all([
        api.freelances.getOneBySlug({slug: this.props.match.params.slug}),
        api.skills.humans.getAll(),
      ])

      const [userResponse, ReviewResponse] = await Promise.all([
        api.users.getOne({user: freelanceResponse.data?.user?.id}),
        api.freelances.reviews.getAll({freelance: freelanceResponse.data.id}),
      ])

      this.setState({
        profile: {
          user: userResponse.data,
          freelance: freelanceResponse.data,
          reviews: ReviewResponse.data.reviews && ReviewResponse.data.reviews.length > 0 ? ReviewResponse.data.reviews[0] : null,
          human_skills: HumanSkillsResponse.data,
        },
        loading: false
      })
    } catch (e) {
      console.warn(e)
      this.setState({loading: false})
    }
  }

  refresh = (profile) => {
    this.setState({profile})
  }

  render() {
    return (
      <>
        <Loader visible={this.state.loading}/>

        <StrategyFreelanceContainer
          currentUser={this.props.currentUser}
          link={{
            menu: 'freelance-profile',
            parameters: {
              slug: this.state.profile ? this.state.profile.freelance.id : null,
            },
            search: null,
          }}
          loading={!this.props.endLoadingCurrentUser && this.state.loading}
          navbar={true}
          profile={this.state.profile}
          wrapWithLayout={true}
          refresh={this.refresh}
          route={this.props.route}
          view={this.state.view}
        />
      </>
    )
  }
}

export default connect(
  (state) => ({
    currentUser: state?.currentUser?.user,
    currentFreelance: state?.currentUser?.freelance,
    endLoadingCurrentUser: state?.currentUser?.endLoading,
    isAdmin: isAdmin(state?.currentUser?.user, state?.universe?.currentUniverse),
    currentUniverseId: state?.universe?.currentUniverse?.id ?? null,
    universes: state?.universe?.universes
  }),
  dispatch => ({
    cancelCurrentUserLoader: () => dispatch(cancelLoader()),
    loadUniverse: (universe) => dispatch(loadUniverse(universe)),
  })
)(ProfileFreelanceContainer)